module.exports = __webpack_public_path__ + "img/ig.537113bf.svg";